module.exports = __webpack_public_path__ + "img/ico-arrow-right-orange.f0879dd5.svg";